import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppInitService } from './app.init.service';
import { BrevoChatService } from './shared/services/brevo-chat.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    isLoading = true;

    // Pages where the Brevo chat widget is allowed (public lead-gen pages only).
    private readonly chatRoutes = ['/login', '/onboarding'];

    constructor(
        private appInitService: AppInitService,
        private router: Router,
        private brevoChat: BrevoChatService,
    ) {}

    ngOnInit(): void {
        this.appInitService.initApp().finally(() => {
            this.isLoading = false;
        });

        // Show the chat widget only on public lead-gen pages; hide it everywhere else so it
        // never overlaps UI in the authenticated app.
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
                const url = (event as NavigationEnd).urlAfterRedirects || '';
                const path = url.split('?')[0].split('#')[0];
                if (this.chatRoutes.some((route) => path.startsWith(route))) {
                    this.brevoChat.show();
                } else {
                    this.brevoChat.hide();
                }
            });
    }
}
